import { useTranslations } from 'app/features/Gallery/hooks/useTranslations'
import { CARE_TILE_PRICING_TEXT, AVAILABLE_LOCALE_FOR_PRICE } from 'app/features/Gallery/components/PreviewArea/CareTile/constants'

export const useCareTileContent = (locale: i18n.Locale) => {
  const localize = useTranslations()
  const shouldRenderPricing = locale === AVAILABLE_LOCALE_FOR_PRICE

  if (shouldRenderPricing) {
    return {
      ctaText: CARE_TILE_PRICING_TEXT.CTA_TEXT,
      captionText: CARE_TILE_PRICING_TEXT.CAPTION_TEXT,
      headingText: CARE_TILE_PRICING_TEXT.HEADING_TEXT,
    }
  }
  return {
    ctaText: localize('CareTileCTAText'),
    captionText: localize('CareTileCaptionTextVariant'),
    headingText: localize('CareTileHeadingVariant'),
  }
}
